'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { trackEvent } from '@/lib/analytics';

interface CTACardProps {
  title?: string;
  description?: string;
  buttonText?: string;
  variant?: 'primary' | 'subtle';
  /** Where on the site this CTACard is shown — surfaced as `event_label` in
   *  PostHog/GA4 so we can compare conversion across placements. */
  source?: string;
}

const CTACard: React.FC<CTACardProps> = ({
  title = 'Ready to transform your grading?',
  description = 'See how IntelGrader can save your tutoring centre 10+ hours per week with AI-powered grading.',
  buttonText = 'Book a Demo',
  variant = 'primary',
  source = 'cta_card',
}) => {
  const router = useRouter();

  return (
    <div className={`cta-card cta-card--${variant}`}>
      <h3 className="cta-card__title">{title}</h3>
      <p className="cta-card__desc">{description}</p>
      <button
        onClick={() => {
          trackEvent('book_demo_click', 'CTA', source);
          router.push('/book-demo');
        }}
        className="cta-card__btn"
      >
        {buttonText} &rarr;
      </button>
    </div>
  );
};

export default CTACard;
